<hyperkit-dialog
  class="hyperkit-component"
  [headerText]="options.headerText"
  [primaryButtonText]="options.primaryButtonText"
  (primaryAction)="onSubmit()"
>
  <hyperkit-code-block [code]="originalQuery() ?? ''"></hyperkit-code-block>
</hyperkit-dialog>
